export const LOGIN = 'login';
export const CONTACT = 'contact';
